<template>
    <div class="kepco-header">
        <div class="kepco-header-left">
            <button
                v-if="selectedCustNo"
                class="kepco-back-btn"
                @click="$emit('go-to-dashboard')"
                title="대시보드로 돌아가기"
            >
                <i class="fas fa-arrow-left"></i>
            </button>
            <div class="kepco-header-title-section">
                <div class="kepco-header-title-row">
                    <div v-if="title.type === 'dashboard'" class="kepco-header-title-wrapper">
                        <div class="kepco-header-title">{{ title.custNm }}</div>
                    </div>
                    <div v-else-if="title.type === 'bill'" class="kepco-header-title-wrapper">
                        <div class="kepco-header-title">{{ title.custNm }}</div>
                        <div class="customer-badge">{{ title.custNo }}</div>
                    </div>

                    <!-- 상태 + 메시지 통합 -->
                    <div v-if="statusMessage && dataStatus" class="kepco-status-message-unified" :class="dataStatus">
                        <!-- <span class="status-marker"></span> -->
                        <span class="status-label">{{ getStatusText(dataStatus) }}</span>
                        <span class="status-separator">·</span>
                        <span class="message-text">{{ statusMessage }}</span>
                    </div>

                    <!-- <div class="customer-badge">
                        {{ selectedPeriod === "monthly" ? currentDateDisplay : currentYearDisplay }}
                    </div> -->
                </div>
            </div>
        </div>
        <div class="kepco-header-right">
            <!-- 고객 선택 -->
            <div class="kepco-customer-select-container">
                <select v-model="localSelectedCustNo" class="kepco-customer-select" @change="onCustomerSelect">
                    <option :value="null">전체</option>
                    <option v-for="customer in customerList" :key="customer.custNo" :value="customer.custNo">
                        {{ customer.custNm }}
                    </option>
                </select>
            </div>
            <div class="kepco-period-toggle">
                <button
                    :class="['kepco-toggle-btn', { active: selectedPeriod === 'monthly' }]"
                    @click="handlePeriodToggle('monthly')"
                >
                    월간
                </button>
                <button
                    :class="['kepco-toggle-btn', { active: selectedPeriod === 'yearly' }]"
                    @click="handlePeriodToggle('yearly')"
                >
                    연간
                </button>
            </div>
            <!-- 날짜 선택기 -->
            <div class="kepco-date-picker-container" :class="{ loading: isLoading }" ref="datePickerContainer">
                <button
                    class="kepco-nav-btn kepco-prev-btn"
                    @click="$emit('navigate-date', -1)"
                    :disabled="isNavigationDisabled || isLoading"
                >
                    <i class="fas fa-chevron-left"></i>
                </button>

                <div class="kepco-date-display" @click="!isLoading && toggleDatePicker()">
                    <span class="kepco-date-text">
                        {{ selectedPeriod === "monthly" ? currentDateDisplay : currentYearDisplay }}
                    </span>
                    <div class="kepco-dropdown-icon-container">
                        <i
                            v-if="isLoading"
                            class="fas fa-spinner fa-spin kepco-loading-icon"
                        ></i>
                        <i
                            v-else
                            :class="['fas fa-chevron-down kepco-dropdown-icon', { open: showDatePicker }]"
                        ></i>
                    </div>
                </div>

                <button
                    class="kepco-nav-btn kepco-next-btn"
                    @click="$emit('navigate-date', 1)"
                    :disabled="isNavigationDisabled || isLoading"
                >
                    <i class="fas fa-chevron-right"></i>
                </button>

                <!-- 드롭다운 메뉴 -->
                <div v-if="showDatePicker" class="kepco-date-picker-dropdown">
                    <div v-if="selectedPeriod === 'monthly'" class="kepco-month-picker">
                        <div class="kepco-year-selector">
                            <button @click="$emit('change-year', -1)" class="kepco-year-nav-btn">
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <span class="kepco-year-display">{{ currentYear }}</span>
                            <button @click="$emit('change-year', 1)" class="kepco-year-nav-btn">
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                        <div class="kepco-month-grid">
                            <button
                                v-for="month in months"
                                :key="month.value"
                                :class="['kepco-month-btn', { active: month.value === currentMonth + 1 }]"
                                @click="$emit('select-month', month.value)"
                            >
                                {{ month.name }}
                            </button>
                        </div>
                    </div>

                    <div v-else class="kepco-year-picker">
                        <div class="kepco-year-list">
                            <button
                                v-for="year in yearRange"
                                :key="year"
                                :class="['kepco-year-btn', { active: year === currentYear }]"
                                @click="$emit('select-year', year)"
                            >
                                {{ year }}년
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <button
                v-if="selectedCustNo"
                class="kepco-hourly-analysis-btn"
                :class="{ disabled: selectedPeriod === 'yearly' }"
                :disabled="selectedPeriod === 'yearly'"
                @click="openHourlyUsageAnalysis"
                :title="selectedPeriod === 'yearly' ? '월간 기간에서만 사용 가능합니다' : '데이터 분석'"
            >
                <i class="fas fa-clock"></i>
                데이터 분석
            </button>
            <button @click="$emit('export-pdf')" class="kepco-pdf-btn">
                <i class="fas fa-download"></i>
                PDF 다운로드
            </button>
        </div>

        <!-- 시간대별 사용량 분석 모달 -->
        <HourlyUsageAnalysisModal
            v-if="selectedCustNo"
            :show="showHourlyUsageModal"
            :regDt="getDate(selectedPeriod)"
            :custNo="selectedCustNo"
            :meterNo="null"
            @update:show="showHourlyUsageModal = $event"
        />
    </div>
</template>

<script>
import HourlyUsageAnalysisModal from "../bill/HourlyUsageAnalysisModal.vue";

export default {
    name: "KepcoHeader",
    components: {
        HourlyUsageAnalysisModal,
    },
    props: {
        title: {
            type: Object,
            default: () => ({
                type: "dashboard",
                custNm: "전기요금",
                custNo: "-",
            }),
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
        currentDateDisplay: {
            type: String,
            default: "",
        },
        currentYearDisplay: {
            type: String,
            default: "",
        },
        currentYear: {
            type: Number,
            default: new Date().getFullYear(),
        },
        currentMonth: {
            type: Number,
            default: new Date().getMonth(),
        },
        customerList: {
            type: Array,
            default: () => [],
        },
        selectedCustNo: {
            type: [String, Number],
            default: null,
        },
        isNavigationDisabled: {
            type: Boolean,
            default: false,
        },

        months: {
            type: Array,
            default: () => [
                { value: 1, name: "1월" },
                { value: 2, name: "2월" },
                { value: 3, name: "3월" },
                { value: 4, name: "4월" },
                { value: 5, name: "5월" },
                { value: 6, name: "6월" },
                { value: 7, name: "7월" },
                { value: 8, name: "8월" },
                { value: 9, name: "9월" },
                { value: 10, name: "10월" },
                { value: 11, name: "11월" },
                { value: 12, name: "12월" },
            ],
        },
        yearRange: {
            type: Array,
            default: () => {
                const currentYear = new Date().getFullYear();
                const years = [];
                for (let i = currentYear - 5; i <= currentYear + 5; i++) {
                    years.push(i);
                }
                return years;
            },
        },
        summaryInfo: {
            type: Object,
            default: null,
        },
        dataStatus: {
            type: String,
            default: "active", // active | pending | predicted
        },
        statusMessage: {
            type: String,
            default: "",
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDatePicker: false,
            localSelectedCustNo: null,
            showHourlyUsageModal: false,
        };
    },
    watch: {
        selectedCustNo: {
            handler(newVal) {
                this.localSelectedCustNo = newVal;
            },
            immediate: true,
        },
    },
    mounted() {
        document.addEventListener("click", this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleOutsideClick);
    },
    methods: {
        toggleDatePicker() {
            this.showDatePicker = !this.showDatePicker;
        },
        handleOutsideClick(event) {
            if (this.$refs.datePickerContainer && !this.$refs.datePickerContainer.contains(event.target)) {
                this.showDatePicker = false;
            }
        },
        onCustomerSelect() {
            this.$emit("select-customer", this.localSelectedCustNo);
        },
        handlePeriodToggle(period) {
            this.$emit("update:selectedPeriod", period);
        },
        formatSummaryNumber(value) {
            const num = Number(value);
            if (isNaN(num)) return "-";
            if (num >= 100000000) {
                return (num / 100000000).toFixed(1) + "억";
            } else if (num >= 10000) {
                return (num / 10000).toFixed(1) + "만";
            }
            return num.toLocaleString();
        },
        getStatusText(status) {
            const statusMap = {
                pending: "대기",
                predict: "예측",
                active: "청구",
            };
            return statusMap[status] || status;
        },
        getDate(type) {
            const year = this.currentYear;
            const month = String(this.currentMonth + 1).padStart(2, "0");
            if (type === "monthly") {
                return `${year}${month}`;
            } else if (type === "yearly") {
                return `${year}`;
            }
        },
        openHourlyUsageAnalysis() {
            if (!this.selectedCustNo) {
                this.$bvToast?.toast("고객번호가 없습니다.", {
                    title: "오류",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            if (this.selectedPeriod === "yearly") {
                this.$bvToast?.toast("월간 기간에서만 사용 가능합니다.", {
                    title: "알림",
                    variant: "warning",
                    solid: true,
                });
                return;
            }
            this.showHourlyUsageModal = true;
        },
    },
};
</script>

<style scoped>
.kepco-header-cust-no {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.15);
    padding: 4px 12px;
    border-radius: 16px;
}
.kepco-header {
    background: #546e7a;
    color: white;
    padding: 10px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-height: 56px;
    /* border: 1px solid #475569; */
}

.kepco-header-left {
    position: relative;
    z-index: 1;
    display: flex;
    gap: 9px;
    align-items: center;
    flex: 1;
}

.kepco-header-title-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
}

.kepco-header-title-row {
    display: flex;
    gap: 9px;
    align-items: center;
}

.kepco-header-title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.kepco-back-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);
    padding: 0;
    flex-shrink: 0;
}

.kepco-back-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateX(-2px);
}

.kepco-back-btn:active {
    transform: translateX(-1px);
}

.kepco-back-btn i {
    font-size: 12px;
}

.kepco-header-title {
    font-size: 24px;
    font-weight: 800;
    margin: 0px !important;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    letter-spacing: -0.5px;
    line-height: 1.2;
    display: flex;
    align-items: center;
}

.customer-badge {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.15);
    padding: 7px 12px;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    line-height: 1;
    flex-shrink: 0;
}

.kepco-customer-select-container {
    display: flex;
    align-items: center;
    margin-left: 16px;
}

.kepco-customer-select {
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.95);
    color: #1e293b;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    min-width: 150px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.kepco-customer-select:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

.kepco-customer-select option {
    background: white;
    color: #1e293b;
}

/* 요약 정보 */
.kepco-header-summary {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 16px;
    padding: 6px 16px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    backdrop-filter: blur(10px);
}

.kepco-summary-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: center;
}

.kepco-summary-label {
    font-size: 10px;
    font-weight: 600;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.kepco-summary-value {
    font-size: 13px;
    font-weight: 700;
    color: white;
}

.kepco-summary-divider {
    width: 1px;
    height: 30px;
    background: rgba(255, 255, 255, 0.3);
}

.kepco-header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 1;
}

.kepco-period-toggle {
    display: flex;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 2px;
    backdrop-filter: blur(10px);
}

.kepco-toggle-btn {
    padding: 6px 12px;
    background: transparent;
    color: rgba(255, 255, 255, 0.8);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.kepco-toggle-btn:focus {
    outline: none;
}

.kepco-toggle-btn.active {
    background: rgba(255, 255, 255, 0.3);
    color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.kepco-toggle-btn:hover:not(.active) {
    background: rgba(255, 255, 255, 0.1);
    color: white;
}

.kepco-date-picker-container {
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 0;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    min-width: 250px;
    z-index: 9999;
    backdrop-filter: blur(10px);
    position: relative;
}

.kepco-nav-btn {
    background: none;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    color: #64748b;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.kepco-nav-btn:hover:not(:disabled) {
    color: #3b82f6;
    background: #f1f5f9;
}

.kepco-nav-btn:focus {
    outline: none;
}

.kepco-nav-btn:disabled {
    color: #cbd5e1;
    cursor: not-allowed;
}

.kepco-date-display {
    flex: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 120px;
    border-left: 1px solid #e2e8f0;
    border-right: 1px solid #e2e8f0;
    transition: all 0.2s ease;
    padding: 3px 12px;
}

.kepco-date-display:hover {
    background: #f8fafc;
}

.kepco-date-text {
    font-size: 14px;
    font-weight: 900;
    color: #1e293b;
    display: flex;
    justify-content: center;
    width: 80%;
}

.kepco-dropdown-icon-container {
    width: 20%;
    display: flex;
    justify-content: center;
}

.kepco-dropdown-icon {
    font-size: 10px;
    color: #64748b;
    transition: transform 0.2s ease;
}

.kepco-dropdown-icon.open {
    transform: rotate(180deg);
}

.kepco-loading-icon {
    font-size: 10px;
    color: #64748b;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.kepco-date-picker-container.loading {
    opacity: 0.7;
    pointer-events: none;
}

.kepco-date-picker-container.loading .kepco-date-display {
    cursor: wait;
}

.kepco-date-picker-container.loading .kepco-date-text {
    opacity: 0.8;
}

.kepco-date-picker-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    margin-top: 6px;
    padding: 16px;
    min-width: 240px;
}

.kepco-year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.kepco-year-nav-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 4px 8px;
    cursor: pointer;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;
}

.kepco-year-nav-btn:focus {
    outline: none;
}

.kepco-year-nav-btn:hover {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
}

.kepco-year-display {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
}

.kepco-month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
}

.kepco-month-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    transition: all 0.2s ease;
}

.kepco-month-btn:hover {
    background: #e2e8f0;
}

.kepco-month-btn.active {
    background: #3b82f6;
    color: white;
}

.kepco-year-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    max-height: 160px;
    overflow-y: auto;
}

.kepco-year-btn {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 4px;
    cursor: pointer;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    transition: all 0.2s ease;
}

.kepco-year-btn:hover {
    background: #e2e8f0;
}

.kepco-year-btn.active {
    background: #3b82f6;
    color: white;
}

.kepco-pdf-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    gap: 6px;
}

.kepco-pdf-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
}

.kepco-pdf-btn i {
    font-size: 11px;
}

.kepco-hourly-analysis-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    white-space: nowrap;
}

.kepco-hourly-analysis-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.kepco-hourly-analysis-btn:active {
    background: rgba(255, 255, 255, 0.25);
}

.kepco-hourly-analysis-btn i {
    font-size: 12px;
}

.kepco-hourly-analysis-btn:disabled,
.kepco-hourly-analysis-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
}

.kepco-hourly-analysis-btn:disabled:hover,
.kepco-hourly-analysis-btn.disabled:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: none;
    transform: none;
}

/* 상태 + 메시지 통합 */
.kepco-status-message-unified {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    max-width: fit-content;
    transition: all 0.2s ease;
}

.kepco-status-message-unified:hover {
    background: rgba(255, 255, 255, 0.12);
}

.kepco-status-message-unified .status-marker {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
}

.kepco-status-message-unified.pending .status-marker {
    background: #fbbf24;
}

.kepco-status-message-unified.predict .status-marker {
    background: #c084fc;
}

.kepco-status-message-unified.active .status-marker {
    background: #34d399;
}

.kepco-status-message-unified .status-label {
    font-size: 11px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
}

.kepco-status-message-unified .status-separator {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 2px;
}

.kepco-status-message-unified .message-text {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.4;
    letter-spacing: 0.2px;
}
</style>
